export default __webpack_public_path__ + "img/teralogo.645c1a59.png";